import React from 'react';
import PropTypes from 'prop-types';

const TwitterFilled = props => {
  const { id, ...rest } = props;

  return (
    <svg
      id={id}
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M23.575.189c-.3-.201-.798-.201-1.098 0-.698.503-1.497.905-2.295 1.207-1.996-1.81-5.089-1.911-7.184 0C11.7 2.4 11.002 3.91 11.002 5.519c-2.894-.201-5.488-1.71-7.185-4.123-.2-.302-.499-.403-.898-.403s-.698.302-.798.604c-.1.1-1.098 2.514-.998 5.43.1 2.514 1.098 5.732 4.79 8.045-1.497.704-3.193 1.006-4.89 1.006-.399 0-.898.302-.998.704-.1.402.1.905.5 1.106C3.018 19.296 5.712 20 8.207 20s4.89-.603 7.085-1.91c4.29-2.414 6.685-7.04 6.685-12.571v-.503c.998-1.106 1.697-2.414 1.996-3.822a.96.96 0 0 0-.4-1.005z"
        id={`${id}-path`}
      />
    </svg>
  );
};

TwitterFilled.propTypes = {
  id: PropTypes.string,
};

TwitterFilled.defaultProps = {
  id: 'twitter-filled',
};

export default TwitterFilled;
